import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./Motion";
import { CTAButton } from "./CTAButton";

export const FaqList = ({ faqs, note }) => (
  <section className="border-b border-border">
    <div className="mx-auto max-w-[1000px] px-6 py-20 lg:px-10 lg:py-28">
      <Accordion type="single" collapsible className="border-t border-border" data-testid="faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
            <AccordionTrigger className="py-6 text-left font-serif text-xl font-normal hover:text-accent hover:no-underline lg:text-2xl" data-testid={`faq-trigger-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      {note && (
        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-col items-start gap-4 border border-border p-8 lg:flex-row lg:items-center lg:justify-between">
            <p className="max-w-md text-muted-foreground">{note}</p>
            <CTAButton to="/contact" variant="accent" testid="faq-contact-btn">Ask a Question</CTAButton>
          </div>
        </Reveal>
      )}
    </div>
  </section>
);
